import { Schema } from '@blade/std-lib'

export class WikiPageSummary extends Schema.Class<WikiPageSummary>(
  'WikiPageSummary',
)({
  // type: Schema.Literal('standard'),
  title: Schema.UndefinedOrFromOptional(Schema.String),
  thumbnail: Schema.UndefinedOrFromOptional(
    Schema.Struct({
      source: Schema.UndefinedOrFromOptional(Schema.URLFromString),
    }),
  ),
  timestamp: Schema.UndefinedOrFromOptional(Schema.DateFromString),
  extract: Schema.UndefinedOrFromOptional(Schema.String),
  description: Schema.UndefinedOrFromOptional(Schema.String),
}) {
  static decode = Schema.decodeUnknownOption(WikiPageSummary)

  get resolvedDescription() {
    return this.extract || this.description
  }

  get hasVisibleContent() {
    return [this.resolvedDescription, this.thumbnail?.source, this.title].some(
      (x) => !!x,
    )
  }
}
